<template>
  <div class="right-offers-panel">
    <SubmittedOffersCombined :type="titleType"></SubmittedOffersCombined>
    <BulkSubmitList :type="titleType" v-if="useBulkSubmission" @submitAll="submitAll" @cancelOffer="cancelOffer"></BulkSubmitList>
    <SkippedList :title="'Skipped Call Verified Schools'" :skipped-offers="cvSkippedOffers" @unskipOffer="unskip" v-if="!extraOnly"></SkippedList>
    <SkippedList :title="'Skipped Warm Transfer Schools'" :skipped-offers="wtSkippedOffers" @unskipOffer="unskip" v-if="!extraOnly"></SkippedList>
    <SkippedList :title="'Skipped Offers'" :skipped-offers="extraSkippedOffers" @unskipOffer="unskip" v-if="extraSkippedOffers.length > 0 || extraOnly"></SkippedList>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BulkSubmitList from './offer-minilists/BulkSubmitList.vue'
import SkippedList from './offer-minilists/SkippedList.vue'
import SubmittedOffersCombined from './offer-minilists/SubmittedOffersCombined.vue'

export default {
  name: 'RightOffersPanel',
  props: ['skippedOffers', 'extraOnly'],
  emits: ['unskipOffer', 'submitAll', 'cancelOffer'],
  components: {
    BulkSubmitList,
    SkippedList,
    SubmittedOffersCombined
  },
  data () {
    return {
    }
  },
  computed: {
    cvSkippedOffers () {
      return this.skippedOffers.callVerified ? this.skippedOffers.callVerified : []
    },
    wtSkippedOffers () {
      return this.skippedOffers.warmTransfer ? this.skippedOffers.warmTransfer : []
    },
    extraSkippedOffers () {
      return this.skippedOffers.extra ? this.skippedOffers.extra : []
    },
    titleType () {
      return this.extraOnly ? 'Offers' : 'Schools'
    },
    ...mapGetters({
      useBulkSubmission: 'consumer/useBulkSubmission'
    })
  },
  methods: {
    unskip (offer) {
      this.$emit('unskipOffer', offer)
    },
    submitAll () {
      this.$emit('submitAll')
    },
    cancelOffer (offer) {
      this.$emit('cancelOffer', offer)
    }
  }
}
</script>

<style scoped>
</style>
